module.exports = __webpack_public_path__ + "img/yearBg.06d01170.png";